<template>
    <div>
        <div v-if="model.latest_interaction">
            <font-awesome-icon
                :icon="model.latest_interaction.icon"
                :class="model.latest_interaction.color"
            />
            <span :class="model.latest_interaction.color">
                {{ model.latest_interaction.label }}
            </span>
        </div>
        <span v-else>-</span>
    </div>
</template>

<script>
    export default {
        props: {
            model: {
                type: Object,
                required: true,
            },
        },
    };
</script>
